<template>
  <div v-if="guestStatistics">
    <popup-add-guest ref="popupAddGuest" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4 mb-4">Guest profiles</h3>
        <p>There are {{ guestStatistics.numberOfGuests }} guests registered.</p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="$refs.popupAddGuest.show()"
            type="relief"
            vslor="primary"
            v-if="$AuthService.hasPermission('vp.crm.guestprofiles.create')"
            >Add guest manually</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="40"
        :data="guestProfiles.length > 0 ? guestProfiles : guestStatistics.latestGuests"
        :noDataText="
          !hasSearched
            ? 'Type name, e-mail or phone in the search field and press enter to find a guest'
            : 'No guests matched'
        "
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <vs-input
            type="search"
            v-model="query"
            v-on:keyup.enter="onSearch"
            border
            placeholder="Search"
            class="search mr-2"
          />

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>City</vs-th>
          <vs-th>E-mail</vs-th>
          <vs-th>Last active</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.firstName + " " + tr.lastName }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.city }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.email }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  Last active {{ moment(tr.lastActive).format("DD-MM-YYYY") }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupAddGuest from "./profile/PopupAddGuest.vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: { PopupAddGuest },
  data() {
    return {
      moment,
      query: "",
      hasSearched: false,
      newMessageTitle: "",
      selected: [],
    };
  },
  methods: {
    async onSearch() {
      if (this.query == "") {
        this.hasSearched = false;
        await this.$store.dispatch("guestProfiles/clearQuery");
      } else {
        this.$vs.loading();
        await this.$store.dispatch("guestProfiles/queryGuests", this.query);
        this.$vs.loading.close();
        this.hasSearched = true;
      }
    },

    onClicked(id) {
      this.$router
        .push({
          name: "crm-guest-profile",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Profile lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      guestProfiles: "guestProfiles/queryResult",
      guestStatistics: "guestProfiles/guestStatistics",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("guestProfiles/getStatistics");
    this.$vs.loading.close();
  },
};
</script>
